/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Detailed_QuoteInputs */

const en_case_doc_detailed_quote = /** @type {(inputs: Case_Doc_Detailed_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detailed repair estimate`)
};

const pt_br2_case_doc_detailed_quote = /** @type {(inputs: Case_Doc_Detailed_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orçamento detalhado reparo`)
};

/**
* | output |
* | --- |
* | "Detailed repair estimate" |
*
* @param {Case_Doc_Detailed_QuoteInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_detailed_quote = /** @type {((inputs?: Case_Doc_Detailed_QuoteInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Detailed_QuoteInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_detailed_quote(inputs)
	return pt_br2_case_doc_detailed_quote(inputs)
});